import React from 'react';
import PropTypes from 'prop-types';
import './PsDocumentSchemasTd.css';

export const PsDocumentWorkerPositionTd = (
    {
        schemas,
    },
) => {
    return (
        <div className="ps-document-schemas-td">
            {
                schemas.map((position) => <span>{position}</span>)
            }
        </div>
    );
};

PsDocumentWorkerPositionTd.propTypes = {
    schemas: PropTypes.array,
};

PsDocumentWorkerPositionTd.defaultProps = {
    schemas: [],
};



// WEBPACK FOOTER //
// ./src/app/shared/components/document-schemas-td/PsDocumentWorkerPositionTd.jsx